import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-opt-report-header',
  templateUrl: './opt-report-header.component.html',
  styleUrls: ['./opt-report-header.component.scss']
})
export class OptReportHeaderComponent implements OnInit {


  @Input() pageHeading: string;

  isShowDivIf = false;
  isGraph = false;
  ismonthly = false;
  isgrapandData = false;
  isdatewise = false;
  isnewcolor = false;
  isdoctor: boolean = false;

  // @Output() toggleDisplayDivIf: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
  // @Output() togglegraphIf: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
  // @Output() togglegraphDataIf: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
  @Output() openPDF: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
  @Output() exportexcel: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
  @Output() printPDF: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
  constructor(public dialog: MatDialog) {
    this.pageHeading = 'OPD Date Wise Reports';
  }

  ngOnInit(): void {
    if (this.pageHeading === 'OPD Date Wise Reports') {
      this.isdoctor = false;
    }
    else {
      this.isdoctor = true;
    }

  }


  toggleDisplayDiv(event: MouseEvent) {
    this.isShowDivIf = !this.isShowDivIf;
  }

  public onButtonClick(event: MouseEvent): void {
    this.isgrapandData = !this.isgrapandData;
  }

  togglegraph() {
    this.isGraph = !this.isGraph;
  }

  togglegraphData() {
    this.isgrapandData = !this.isgrapandData;
  }
  togglemonthely() {
    this.ismonthly = !this.ismonthly;
  }

  

}
